import { useInstance } from 'common-module/src/util/useInstance';
import { computed } from '@vue/composition-api';

export const useShare = () => {
  const instance = useInstance();
  const roles = computed<Array<{ roleCode: string }>>(
    () => instance.$store.state.user.roles || []
  );
  const enterPreviewMode = computed<boolean>(
    () => instance.$store.state.user.enterPreviewMode
  );
  const isVisitor = computed(() =>
    roles.value.some(r => r.roleCode === 'anonymous') || enterPreviewMode.value
  );
  const shareInfo = computed(() => instance.$store.state.user.shareInfo);

  return {
    isVisitor,
    shareInfo,
    shareProjectId: computed<number | undefined>(() => shareInfo.value.projectId)
  };
};

export type ShareStore = ReturnType<typeof useShare>;
